module.exports = __webpack_public_path__ + "static/media/03B2.d9a5f115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/03B2.png
// module id = 269
// module chunks = 0